import styled from "styled-components";

import {
  HexMenuItem,
  MENU_ITEM_HEIGHT,
} from "../../../hex-components/HexMenuItem.js";

// forced height otherwise the icons will change the menu items when displayed
export const FixedHeightMenuItem = styled(HexMenuItem)`
  height: ${MENU_ITEM_HEIGHT}px;
  /* Hover action alignment */
  padding-right: 3px;
`;
